import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { routes } from './app.routes';
import { coreInterceptorProvider } from './http-interceptors/core.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { encryptionInterceptorProvider } from './http-interceptors/encryption.interceptor';
import { environment } from 'src/environments/environment';

const currentAppConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom(HttpClientModule),
    coreInterceptorProvider,
    provideAnimations(),
  ],
};

if (environment.dataEncryptionEnabled) {
  currentAppConfig.providers.push(encryptionInterceptorProvider);
}

export const appConfig = currentAppConfig;